import { render, staticRenderFns } from "./DropFilePopup.vue?vue&type=template&id=10cff6ed"
import script from "./DropFilePopup.vue?vue&type=script&lang=js"
export * from "./DropFilePopup.vue?vue&type=script&lang=js"
import style0 from "./DropFilePopup.vue?vue&type=style&index=0&id=10cff6ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports